import { authRoles } from 'app/auth';
import VizsgazoSubmitForm from './editform/VizsgazoSubmitForm';
import VizsgazoEditForm from './editform/VizsgazoEditForm';
import VizsgazoTable from './table/VizsgazoTable';

export default [
	{
		path: '/vizsgazo/edit/new/:examId',
		component: VizsgazoSubmitForm,
		auth: authRoles.admin
	},
	{
		path: '/vizsgazo/edit/:id',
		component: VizsgazoEditForm,
		auth: authRoles.admin
	},
	{
		path: '/vizsgazo/:sessionNameParam?',
		component: VizsgazoTable,
		auth: authRoles.admin
	}
];
